<template>
  <div
    v-if="showLoadingState < 2"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="assetSendingOfDeliverables"
  >
    <div class="align-items-baseline display-flex-row m-filters-and-actions">
      <form
        autocomplete="off"
        class="align-items-baseline m-form-row"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomInputPrimary
          v-model="simpleFilter.asunto"
          :disabled="pagination.showLoadingState"
          name="asunto"
          placeholder="Asunto de Entregable"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomSelectPrimary
          v-if="element.fecha_inicio"
          v-model.number="simpleFilter.periodo"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.periods"
          keyField="id"
          name="periodo"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reload"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <div class="m-dropdown-primary">
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.filter"
          :disabled="pagination.showLoadingState"
          @switchDropDown="$dropDown.switchDropDown"
        />
        <MoleculeEditionMapActivationSendingOfDeliverablesDropDownFilters
          :element="element"
          :filter-seted="filter"
          @reloadListing="reloadListing"
          @searchAdvancedFilter="searchAdvancedFilter"
        />
      </div>

      <AtomButtonSecondary
        :button-secondary="buttonSecondary.create"
        @createEntregable="createEntregable"
      />
    </div>

    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="entregablesProyecto.length">
          <th
            class="text-align-left"
            width="30%"
          >
            {{ $t('mEditionMapActivationSendingOfDeliverables.table.thSubject') }}
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            {{ $t('mEditionMapActivationSendingOfDeliverables.table.thDate') }}
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            {{ $t('mEditionMapActivationSendingOfDeliverables.table.thType') }}
          </th>
          <th
            class="text-align-center"
            width="15%"
          >
            {{ $t('mEditionMapActivationSendingOfDeliverables.table.thEdit') }}
          </th>
          <th
            class="text-align-center"
            width="15%"
          >
            {{ $t('mEditionMapActivationSendingOfDeliverables.table.thDelete') }}
          </th>
        </tr>
        <tr
          v-for="entregable in entregablesProyecto"
          :key="entregable.id"
          class="row-data"
        >
          <td class="text-align-left">
            <span v-if="entregable.asunto">
              {{ entregable.asunto }}
            </span>
            <span
              v-else
              class="text-color-black-45"
            >
              {{ $t('mEditionMapActivationSendingOfDeliverables.unedited') }}
            </span>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ getEntregableDate(entregable.dia) }}
          </td>
          <td class="text-align-center">
            <span>
              {{ entregablesTipo[entregable.tipo === 'nodo' ? 0 : 1].name }}
            </span>
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.edit"
              :element="entregable"
              @goToEntregableEdition="goToEntregableEdition"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              v-if="entregable.tipo === 'mensaje' || (entregable.tipo === 'nodo' && entregable.nodos.length === 0)"
              :button-icon-rounded="buttonIconRounded.delete"
              :element="entregable"
              @showModal="$modal.showModal"
            />
            <AtomButtonIconRounded
              v-else
              :button-icon-rounded="buttonIconRounded.disabled"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapActivationSendingOfDeliverables',

  components: {
    MoleculeEditionMapActivationSendingOfDeliverablesDropDownFilters: () => import('@/components/molecules/MoleculeEditionMapActivationSendingOfDeliverablesDropDownFilters'),
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      buttonIconRounded: {
        delete: {
          class: 'a-button-secondary a-button-danger-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionMapActivationSendingOfDeliverablesModalDelete',
          icon: 'far fa-trash-alt',
          method: 'showModal',
          tooltip: this.$t('mEditionMapActivationSendingOfDeliverables.tooltip.delete'),
          type: 'button'
        },

        disabled: {
          class: 'a-button-secondary a-button-disabled-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'far fa-trash-alt',
          method: '',
          tooltip: this.$t('mEditionMapActivationSendingOfDeliverables.tooltip.disabled'),
          type: 'button'
        },

        edit: {
          class: 'a-button-secondary a-button-maps-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-pencil-alt',
          method: 'goToEntregableEdition',
          tooltip: this.$t('mEditionMapActivationSendingOfDeliverables.tooltip.edit'),
          type: 'button'
        }
      },

      buttonSecondary: {
        create: {
          class: 'a-button-maps-secondary a-button-side',
          component: '',
          icon: 'fas fa-plus',
          method: 'createEntregable',
          text: this.$t('mEditionMapActivationSendingOfDeliverables.buttonSecondary.createText'),
          type: 'button'
        },

        filter: {
          class: 'a-button-maps-secondary a-button-side',
          component: 'MoleculeEditionMapActivationSendingOfDeliverablesDropDownFilters',
          icon: 'fas fa-filter',
          method: 'switchDropDown',
          text: this.$t('mEditionMapActivationSendingOfDeliverables.buttonSecondary.filterText'),
          type: 'button'
        },

        reload: {
          class: 'a-button-maps-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionMapActivationSendingOfDeliverables.tooltip.reload'),
          type: 'button'
        }
      },

      entregablesProyecto: [],

      entregablesTipo: [
        {
          class: 'text-badge-billing-primary text-badge-primary',
          id: 0,
          name: this.$t('mEditionMapActivationSendingOfDeliverables.type.activation')
        },
        {
          class: 'text-badge-academy-primary text-badge-primary',
          id: 1,
          name: this.$t('mEditionMapActivationSendingOfDeliverables.type.message')
        }
      ],

      filter: {
        asunto: '',
        dia: '',
        tipo: '',
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        mensaje: '',
        pagina: 1
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      proyectoVersiones: [],
      showLoadingState: 0,

      simpleFilter: {
        asunto: '',
        periodo: 0
      },

      version: {}
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    'filter.fecha_desde' () {
      if (this.$moment(this.filter.fecha_desde).isAfter(this.filter.fecha_hasta)) {
        this.filter.fecha_hasta = null
      }

      this.disabledDates = {
        to: this.filter.fecha_desde
      }
    },

    updatedData () {
      this.readContenidoEntregables()
    }
  },

  created () {
    this.readContenidos()
  },

  methods: {
    createEntregable () {
      this.$router.push(`/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.activation.subject')}/${this.version.id}/${this.$t('mEditionMenu.map.activation.children.sendingOfDeliverablesCreate.subedition')}`)
    },

    getEntregableDate (day) {
      return this.element.fecha_inicio
        ? this.$moment.parseZone(this.element.fecha_inicio).add(day, 'days').format('D MMM YYYY')
        : day === 0
          ? this.$t('mEditionMapActivationSendingOfDeliverables.date.inmediate')
          : `${this.$t('mEditionMapActivationSendingOfDeliverables.date.delivery')} ${day}`
    },

    goToEntregableEdition (entregable) {
      this.$store.commit('setAssetSelectedDeliverable', entregable)
      this.$router.push(`/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.activation.subject')}/${entregable.id}/${this.$t('mEditionMenu.map.activation.children.sendingOfDeliverablesEdit.subedition')}`)
    },

    readContenidoEntregables () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('contenido', 'readContenidoEntregables', {}, [this.version.id], this.filter)
          .then(response => {
            this.entregablesProyecto = []
            this.entregablesProyecto = response.data.entregables
            this.pagination.currentQuantity = this.entregablesProyecto.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.showLoadingState++
          })
          .catch(error => {
            console.log(error)
            this.entregablesProyecto = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.showLoadingState++
          })
      }
    },

    readContenidos () {
      this.$services.read('contenido', 'readContenidos', {}, [this.$route.params.id])
        .then(response => {
          this.proyectoVersiones = response.data
          // versión creada by default al crear el proyecto
          this.version = this.proyectoVersiones[0]
          this.readContenidoEntregables()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    reloadListing () {
      this.resetSimpleFilter()
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        asunto: '',
        dia: '',
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        mensaje: '',
        pagina: 1
      }
    },

    resetSimpleFilter () {
      this.simpleFilter = {
        asunto: '',
        periodo: 0
      }
    },

    searchAdvancedFilter (advancedFilter) {
      this.resetSimpleFilter()
      this.filter = Object.assign({}, advancedFilter)
      this.setPaginationCurrentPage(1)
    },

    searchSimpleFilter () {
      this.resetAdvancedFilter()
      if (this.simpleFilter.periodo === '') {
        this.simpleFilter.periodo = 0
      }
      this.filter.asunto = this.simpleFilter.asunto
      this.filter.mensaje = ''
      this.filter.fecha_desde = this.$filters.parameters.periods[this.simpleFilter.periodo].dateFrom
      this.filter.fecha_hasta = this.$filters.parameters.periods[this.simpleFilter.periodo].dateTo
      this.setPaginationCurrentPage(1)
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readContenidoEntregables()
    }
  }
}
</script>
